import Vue, { createApp } from "vue";
import ElementPlus from "element-plus";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-plus/dist/index.css";
import "./assets/css/index.scss";
import "./assets/icons/index.js";
import "@/assets/css/global.scss";
import { directive } from '@/directive/index.js' //引入自定义指令
import { createPinia } from 'pinia';

import { ComponentCustomProperties } from "vue";
import { Store } from "vuex";
declare module "@vue/runtime-core" {
  interface State {
    count: number;
  }

  interface ComponentCustomProperties {
    $store: Store<State>;
  }
}

const app = createApp(App);
const pinia = createPinia();
directive(app) // 全局 click 1秒内不允许点击多次
app.use(store).use(router).use(ElementPlus).use(pinia);
app.mount("#app");

// eslint-disable-next-line @typescript-eslint/no-empty-function
console.log = console.error = console.warn = console.info = function() {};
